module.exports = __webpack_public_path__ + "static/about-image-4_m-f14d338a57fdea605e5e138b938fd1c9.jpg";